<template>
  <v-dialog scrollable max-width="450px" v-model="showDialog">
    <template v-slot:activator="{ on }" >
      <v-btn x-small color="secondary" dark v-on="on" @click="init">
        {{texto}}
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h4>Agregar Observacion</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            type="text"
            label="Observacion"
            v-model="observacion"
            autofocus
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
// import axios from "axios";

export default Vue.extend({
  props: ['texto','ordenPago'],
  data() {
    return {
      loading: false,
      showDialog: false,
      observacion: "",
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {},
  methods: {
    init() {
      this.observacion = '';
      console.log(this.ordenPago);
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      // axios
      //   .post(`/persona/${this.id}/actualizarCedula/${this.nuevaCedula}`)
      //   .then((response) => {
      //     console.log(response);
      //     this.$emit("nuevaCedula", {
      //       id: this.id,
      //       nuevaCedula: this.nuevaCedula,
      //     });
      //     this.close();
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.nuevaCedula = this.cedula;
      //     console.log(err);
      //     this.errorMessage = "Error en la consulta";
      //   });

      this.$emit("nuevaObservacion", {ordenPago: this.ordenPago, observacion: this.observacion});
      this.close();
    },
  },
});
</script>